var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_91)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22686 2.84244L6.76917 1.29427L6.99999 1.06243L7.23114 1.29427L8.77311 2.84244L8.31114 3.30166L7.32691 2.31364V11.6867L8.31114 10.6983L8.77311 11.1579L7.23114 12.7061L6.99999 12.9379L6.76917 12.7061L5.22686 11.1579L5.68883 10.6983L6.67306 11.6867V2.31364L5.68883 3.30166L5.22686 2.84244ZM3.24463 13.3468H10.7553V14.0003H3.24463V13.3468ZM3.24463 0H10.7553V0.653166H3.24463V0Z",
    fill: "#3CBD96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeight);
export default __webpack_public_path__ + "static/media/height.317ff86f1d0dd3dbb49d985ee9cdf628.svg";
export { ForwardRef as ReactComponent };